import app from 'flarum/forum/app';
import addHeaderAndFooter from './header';
import addHome from './home';
import addSectionPages from './sectionPages';
import addDiscussionPage from './discussion';
import addProfile from './profile';
import addSubsectionRule from './subsectionRule';
import addDiscussionList from './lists';
import addAuthLayout from './auth';
import addUploadErrors from './uploads';
import addComposer from './composer';
import addScrollBehaviour from './scroll';
import addSearchLayout from './search';
import addComposerDraft from './composerDraft';
import addInlineReply from './inlineReply';
import addMediaManager from './mediaManager';
import addPasswordVisibility from './passwordVisibility';
import addPasswordHint from './passwordHint';
import addComposerModal from './composerModal';
import addDangerConfirmations from './confirmDanger';
app.initializers.add('tarotportal-theme', () => {
  addHeaderAndFooter();
  addHome();
  addSectionPages();
  addDiscussionPage();
  addProfile();
  addSubsectionRule();
  addComposer(); // after the subsection rule: its checks run first
  addInlineReply(); // after the composer labels and checks: wraps them
  addComposerModal();
  addDangerConfirmations();
  addDiscussionList();
  addAuthLayout();
  addPasswordVisibility();
  addPasswordHint(); // after the eye button: appends a sibling, not a wrapper
  addUploadErrors();
  addMediaManager();
  addScrollBehaviour();
  addSearchLayout();
  addComposerDraft();
},
// After flarum/tags and the other bundled extensions, so their items exist when ours are arranged.
-100);